var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"cartHeader"}},[_vm._v(" RESTAURANTE "),_c('span',{attrs:{"id":"cartRestaurantName"}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }